import { Injectable, Injector } from '@angular/core'
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http'
import { AuthService } from './auth.service'
import { Observable, throwError, BehaviorSubject } from 'rxjs'
import { catchError, filter, take, switchMap } from 'rxjs/operators'
import { Router } from '@angular/router'
import { MessageService } from './message.service'

const whitelist = ['login']

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    private isRefreshing = false
    private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null)

    constructor(private inj: Injector, private router: Router, private messageService: MessageService) {
        console.log('Auth Token interceptor')
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        console.log(`Interceptor ${request.url}`)
        const skip = whitelist.some(str => request.url.includes(str))
        if (skip) {
            return next.handle(request).pipe(
                catchError(err => {
                    this.messageLog(err)
                    return throwError(err)
                })
            )
        }
        const authService = this.inj.get(AuthService)
        if (authService.getJwtToken()) {
            request = this.addToken(request, authService.getJwtToken())
        }

        return next.handle(request).pipe(
            catchError(error => {
                this.messageLog(error)
                if (error instanceof HttpErrorResponse && 401 === error.status) {
                    return this.handle401Error(request, next)
                } else {
                    return throwError(error)
                }
            })
        )
    }

    private messageLog(error: any) {
        let errorMessage = ''
        if (error.error instanceof ErrorEvent) {
            // client-side error
            errorMessage = `Error: ${error.error.message}`
        } else {
            // server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`
        }
        console.log(`ERROR interceptor: ${errorMessage}`)
        this.messageService.addMessage({ message: errorMessage, severity: 'error' })
    }

    private addToken(request: HttpRequest<any>, token: string) {
        return request.clone({
            setHeaders: {
                Authorization: `Bearer ${token}`,
            },
        })
    }

    private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
        if (request.url.includes('refresh')) {
            // ak refresh tokenu fail, redirect to login
            console.log('refreshing access token failed on 401')
            this.router.navigateByUrl('/login')
        }
        if (!this.isRefreshing) {
            this.isRefreshing = true
            this.refreshTokenSubject.next(null)
            const authService = this.inj.get(AuthService)
            return authService.refreshToken().pipe(
                switchMap((token: any) => {
                    this.isRefreshing = false
                    this.refreshTokenSubject.next(token.jwt)
                    return next.handle(this.addToken(request, token.jwt))
                })
            )
        } else {
            return this.refreshTokenSubject.pipe(
                filter(token => token != null),
                take(1),
                switchMap(jwt => {
                    return next.handle(this.addToken(request, jwt))
                })
            )
        }
    }
}
